import React, {useContext, useState} from 'react';
import axios from 'axios';

//Components
import {ModalContext} from 'app/app';
import {IconedButton} from 'components/IconedButton';
import {useNavigate, ViewContext} from 'components/lib';

//Helpers
import QuoteUtils from 'helpers/quoteUtils';

const quoteUtils = new QuoteUtils();

const Header = ({data}) => {
  const navigate = useNavigate();

  const view = useContext(ViewContext);
  const {setModal} = useContext(ModalContext);
  const [isDownloadingQuote, setDownloadingQuote] = useState(false);

  async function downloadQuote() {
    setDownloadingQuote(true);

    try {
      const quotePDFBlob = await quoteUtils.generateQuotePDFBlob(
        data
      );

      const formData = new FormData();
      formData.append('file', quotePDFBlob, `data?.pdf`);

      await axios
        .post('/api/quote/file', formData)
        .then(async (pdf_response) => {
          const link = pdf_response.data.link;

          view.notification.show(
            'PDF Downloaded.',
            'success',
            true,
            'toast',
            'check-circle'
          );

          window.open(link);
        })
        .catch(() => {
          setModal({});

          view.notification.show(
            'Error on upload certificate to server',
            'error',
            true,
            'toast',
            'x-circle'
          );
        });
    } catch (error) {
      console.log(error);
    }

    setDownloadingQuote(false);
  }

  return (
    <div className="w-full flex items-center justify-between">
      <div className="flex">
        <IconedButton
          size="130px"
          color="#d32425"
          textColor="white"
          icon="arrow-left"
          text="Go back"
          action={() => {
            navigate('/admin/quote');
          }}
        />
      </div>
      <div className="flex">
        <IconedButton
          size="315px"
          color="#2963da"
          textColor="white"
          icon="plus-square"
          text="QUOTE THIS WITH PROGRESSIVE"
          marginRight
          action={() => {
            window.open(
              'https://docs.google.com/forms/d/e/1FAIpQLSdKY--wlXq3O8TSU3ZRY2W_k_qZIg8PPpRIK302xkvNQygCrg/viewform',
              '_blank'
            );
          }}
        />
        {data?.financialDetails && (
          <div className="ml-2 flex">
            <IconedButton
              size="170px"
              color="#d32425"
              textColor="white"
              icon="download-cloud"
              text="Download Quote"
              marginRight
              loading={isDownloadingQuote}
              action={async () => {
                await downloadQuote();
              }}
            />
            <IconedButton
              size="170px"
              color="#d32425"
              textColor="white"
              icon="send"
              text="Send via Email"
              marginRight
              action={async () => setModal({
                  name: 'email_quote_modal',
                  data: {
                    data: data,
                    company_name: data.company_name,
                    submission_number: data.submission_number,
                  },
                })
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
